var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8846 5.51491C25.4243 4.02177 23.9775 2.57486 22.4844 3.11589L4.23668 9.71569C2.73863 10.258 2.55746 12.3021 3.93557 13.1005L9.76036 16.4729L14.9617 11.2713C15.1973 11.0437 15.5129 10.9178 15.8405 10.9206C16.1681 10.9234 16.4815 11.0549 16.7132 11.2865C16.9448 11.5182 17.0762 11.8316 17.0791 12.1592C17.0819 12.4868 16.956 12.8024 16.7284 13.0381L11.527 18.2397L14.9005 24.0648C15.6976 25.443 17.7417 25.2606 18.2839 23.7637L24.8846 5.51491Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSendButton);
export default __webpack_public_path__ + "static/media/chat-send-button.f3bba847489161e330aee0a01e428713.svg";
export { ForwardRef as ReactComponent };